const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://irisimpulse.com/#website",

  name: "Iris Impulse India Pvt. Ltd.",
  url: "https://irisimpulse.com/",

  description:
    "Official website of Iris Impulse India Pvt. Ltd., a bentonite manufacturer and industrial minerals exporter from India.",

  publisher: {
    "@id": "https://irisimpulse.com/#organization",
  },

  inLanguage: "en",
});

export default websiteSchema;
